import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  submissionContainer: {
    backgroundColor: theme.palette.bg.main,
    padding: theme.spacing(0),
  },
  dimensionText: {
    marginTop: theme.spacing(1.25),
    marginBottom: theme.spacing(1.25),
  },
  dimensionsContainer: {
    borderBottomColor: theme.palette.detailedOfferBorder.main,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    paddingBottom: theme.spacing(0.25),
  },
  dimensionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  dimensionsHeading: {
    fontSize: '14px',
    color: theme.palette.primary.light,
    textTransform: 'capitalize',
    marginBottom: theme.spacing(0.25),
  },
  eulaContainer: {
    textAlign: 'left',
    paddingBlock: theme.spacing(2),
    borderBottomColor: theme.palette.detailedOfferBorder.main,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
  },
  eulaHeading: {
    fontSize: '14px',
    color: theme.palette.primary.light,
    textTransform: 'capitalize',
    marginBottom: theme.spacing(0.25),
  },
  customEula: {
    marginTop: theme.spacing(1.25),
  },
  eulaText: {
    marginTop: theme.spacing(1.25),
  },
  dateContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBlock: theme.spacing(3),
    borderBottomColor: theme.palette.detailedOfferBorder.main,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
  },
  dateHeading: {
    fontSize: '14px',
    color: theme.palette.primary.light,
    textTransform: 'capitalize',
  },
  dateText: {
    display: 'inline-flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(4),
    gap: theme.spacing(4.375),
  },
  button: {
    fontSize: '12px',
    padding: theme.spacing(1.25, 4.375),
  },
  deactivateButton: {
    padding: theme.spacing(1.25, 4.375),
    color: theme.palette.status.dark,
    borderColor: theme.palette.status.dark,
  },
  modalText: {
    maxWidth: '290px',
    margin: 'auto',
  },
}))
